import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col" }
const _hoisted_2 = { class: "p-3 pb-3 text-center bg-gray-900 text-gray-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl w-72 m-auto mb-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/",
    class: "m-auto"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bg-header-img bg-contain bg-no-repeat bg-center h-10 w-auto" })
  ])
], -1)
const _hoisted_4 = { class: "flex flex-wrap lg:flex-nowrap lg:w-3/5 xl:w-1/2 m-auto justify-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Top")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("News")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Units")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_9 = { class: "w-full md:w-1/2 lg:w-1/3 pt-2 pb-1 px-3 lg:ml-auto" }
const _hoisted_10 = { class: "bg-white flex rounded-full shadow-xl" }
const _hoisted_11 = { class: "bg-blue-500 text-white rounded-full p-1 hover:bg-blue-400 focus:outline-nonee w-10 h-10 justify-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "border-2 border-gray-600 mb-5" }, null, -1)
const _hoisted_13 = { class: "flex-grow" }
const _hoisted_14 = { class: "bg-gray-900 mt-2" }
const _hoisted_15 = { class: "m-auto text-center text-white my-2" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("利用規約")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("ガイドライン")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("プライバシーポリシー")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-center text-sm text-white" }, "© 2021 seigo2016", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa = _resolveComponent("fa")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "text-lg py-3 px-3 mx-3"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/news",
          class: "text-lg py-3 px-3 lg:mx-3"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/unit",
          class: "text-lg py-3 px-3 lg:mx-3"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/about",
          class: "text-lg py-3 px-3 lg:mx-3"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.search(_ctx.query)), ["enter"])),
              "aria-label": "Search",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event)),
              class: "rounded-l-full w-full px-6 text-gray-700 focus:outline-none",
              id: "search",
              type: "text",
              placeholder: "Search"
            }, null, 544), [
              [_vModelText, _ctx.query]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", _hoisted_11, [
                _createVNode(_component_fa, { icon: "search" })
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_link, {
          to: "/terms",
          class: "text-sm my-auto px-5"
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/guideline",
          class: "text-sm my-auto px-5"
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/privacy",
          class: "text-sm my-auto px-5"
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        })
      ]),
      _hoisted_19
    ])
  ]))
}